import React, { ReactNode } from 'react';

const NoDataMessage: React.FC<NoDataMessageProps> = ({ children, extraClasses = '' }) => (
    <p className={`no-message ${extraClasses}`}>{children}</p>
);

interface NoDataMessageProps {
    children: ReactNode;
    extraClasses?: string;
}

export default NoDataMessage;
